/**
 * SignInDialog — the screen before Google.
 *
 * The header's "Sign In" used to send the visitor straight to Google's consent page, so
 * the one thing CHEKSTE must say before an account is created — that continuing accepts
 * the Terms of Service and acknowledges the Privacy Policy — was never on screen. Every
 * sign-in now passes through this card: the Google buttons and the consent line sit
 * together (AuthPrompt), one click away from before.
 */

import React from 'react';
import { LogIn } from 'lucide-react';
import AuthPrompt from './AuthPrompt';

const SignInDialog = ({ open, onClose, lang = 'en', redirectAfterAuth = '/analyze' }) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[60] bg-slate-900/60 flex items-center justify-center p-4"
      data-testid="signin-dialog"
      onClick={onClose}
    >
      <div onClick={(e) => e.stopPropagation()} className="w-full max-w-md">
        <AuthPrompt
          icon={LogIn}
          title={lang === 'en' ? 'Sign in to CHEKSTE' : 'Inicia sesión en CHEKSTE'}
          description={lang === 'en'
            ? 'Use your Google account. New here? The same button creates your free account.'
            : 'Usa tu cuenta de Google. ¿Primera vez? El mismo botón crea tu cuenta gratis.'}
          lang={lang}
          redirectAfterAuth={redirectAfterAuth}
        />
        <button
          type="button"
          onClick={onClose}
          className="mt-3 w-full text-sm text-white/80 hover:text-white min-h-[44px] touch-manipulation"
          data-testid="signin-dialog-dismiss"
        >
          {lang === 'en' ? 'Not now' : 'Ahora no'}
        </button>
      </div>
    </div>
  );
};

export default SignInDialog;
